import type { PartnerAppState } from '../../../redux/types';
import { generateUseSubstateSelector } from '@orthly/redux-async-actions';

export const useChatSelector = generateUseSubstateSelector<PartnerAppState, 'chat'>('chat');
